var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.project)?_c('div',{staticClass:"project-acceptance-report"},[_c('b-row',{staticClass:"mt-4"},[_c('b-col',{attrs:{"lg":"12","md":"12","sm":"12"}},[_c('legend',[_c('strong',[_vm._v(_vm._s(_vm.$t('qualityReport'))+": "+_vm._s(_vm.$t('collected_data')))])]),_c('MobileQualityReport',{attrs:{"project":_vm.project}})],1)],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }